// this function is used to determine if a link should be nofollowed
// based on the uri  => all competitor links should be nofollowed
export const useNoFollowLink = (uri: string): boolean => {
  switch (true) {
    case uri.includes('aha.io'):
    case uri.includes('asana.com'):
    case uri.includes('atlassian.com'):
    case uri.includes('clickup.com'):
    case uri.includes('craft.io'):
    case uri.includes('glidr.io'):
    case uri.includes('miro.com'):
    case uri.includes('monday.com'):
    case uri.includes('pendo.io'):
    case uri.includes('productboard.com'):
    case uri.includes('productplan.com'):
    case uri.includes('prodpad.com'):
    case uri.includes('roadmunk.com'):
    case uri.includes('scoro.com'):
    case uri.includes('trello.com'):
      return true
    default:
      return false
  }
}
